import React, { useContext } from 'react';
import { StaticContext } from '@sm/webassets';

import DeveloperWebBasePage from '../DeveloperWebBasePage';

import './docs.scss';

const Docs = () => {
  const {
    environment: { domain },
  } = useContext(StaticContext);

  return (
    <div className="container-docs" data-testid="Docs__Developer">
      <DeveloperWebBasePage id="Developer - Docs" footer={false} title="SurveyMonkey API Developer Portal">
        <iframe
          title="SurveyMonkey Developer Docs"
          className="docs-frame"
          src={`https://api.${domain}.com/v3/docs?api_key=3yr7n6m8sjwvm48x8nhxej52`}
          width="100%"
          frameBorder="0"
        />
      </DeveloperWebBasePage>
    </div>
  );
};

export default Docs;
